export const pageSizeOptions = [10, 15, 20, 50, 100];

export const defaultRowsPerPage = pageSizeOptions[1]; // Default to 15

export const sortDirections = ['asc', 'desc'];

export const cleanFilters = ({filtersDef, filters}) => {
  if (filters && filtersDef) {
    const filterKeys = Object.keys(filtersDef);
    return filters.split(',').filter(f => filterKeys.includes(f));
  }
  return [];
};
